export default __webpack_public_path__ + "static/media/ideation3.7a1fb34c.png";